import axios from 'axios';
import { AxiosFile, AxiosHttpGet, AxiosHttpPost } from 'axios-http/axiosClient';
import { REPAIR_CENTER } from 'resources/links';

const headerNotContentType = {
    Accept: '*/*',
    Authorization: `a/BnOiT72oiKkcO+xlStRbHkstyPgmMT`
};

export function getRmaDetails(rmaNumber: number) {
    return AxiosHttpPost({ url: REPAIR_CENTER.getRmaDetails, data: { RmaId: rmaNumber } });
}

export function removeFile(fileId: number) {
    return AxiosHttpPost({ url: REPAIR_CENTER.removeFile, data: fileId });
}

export function uploadFile(formFile: any, rmaId: number, ssoId: string, type: string) {
    return AxiosHttpPost({
        url: REPAIR_CENTER.uploadFile,
        headers: { Accept: '*/*', 'Content-Type': 'multipart/form-data' },
        data: { formFile, rmaId, ssoId, type }
    });
}

export function uploadFiles(formFiles: File[], rmaId: string, ssoId: string, type: string) {
    const formData = new FormData();

    formFiles.forEach((file) => {
        formData.append("formFiles", file);
    });

    // Adiciona os outros campos
    formData.append("rmaId", rmaId);
    formData.append("ssoId", ssoId);
    formData.append("type", type);

    return AxiosHttpPost({
        url: REPAIR_CENTER.uploadFiles,
        headers: {
            Accept: '*/*',
        },
        data: formData
    });
}


export function downloadFile(fileId: number, downloadName?: string) {
    return AxiosFile({
        url: REPAIR_CENTER.downloadFile,
        param: { fileId },
        downloadName: downloadName ?? `arquivo-${fileId}`,
    });
}

export function uploadXml(formFile: File) {
    return AxiosHttpPost({
        url: REPAIR_CENTER.uploadXML,
        headers: { "Content-Type": "multipart/form-data" },
        data: { formFile }
    })
}


